import FormatItem from '@/assets/formats/format-item'

import RirekishoSample from '@/assets/formats/sample/rirekisho-sample'
import RirekishoCards from '@/assets/formats/rirekisho-cards'
import RirekishoJISCards from '@/assets/formats/rirekisho-jis-cards'
import NewRirekishoCards from '@/assets/formats/new-rirekisho-cards'
import RirekishoNophotoCards from '@/assets/formats/rirekisho-nophoto-cards'

import RirekishoEdit from '@/components/formats/RirekishoEdit'
import NewRirekishoEdit from '@/components/formats/NewRirekishoEdit'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import RirekishoShortPreview from '@/components/formats/RirekishoShortPreview'
import RirekishoSinglePreview from '@/components/formats/RirekishoSinglePreview'
import NewRirekishoSinglePreview from '@/components/formats/NewRirekishoSinglePreview'
import RirekishoDoubleNophotoPreview from '@/components/formats/RirekishoDoubleNophotoPreview'
import RirekishoSingleNophotoPreview from '@/components/formats/RirekishoSingleNophotoPreview'

import ShokurekishoEdit from '@/components/formats/ShokurekishoEdit'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
// import ShokurekishoPreview from '@/components/formats/ShokurekishoPreviewSample'
import ShokurekishoSample from '@/assets/formats/sample/shokurekisho-sample'
import ShokurekiCards from '@/assets/formats/shokureki-cards'


import LetterEdit from '@/components/formats/LetterEdit'
import LetterSample from '@/assets/formats/sample/letter-sample'
import LetterPreview from '@/components/formats/LetterPreview'
import LetterCards from '@/assets/formats/letter-cards'

const jobChangeExampleSentences = {
  // 志望動機
  reason: {
    'スキルアップのために転職したい': '前職ではX年間にわたってXX業務に携わってきました。貴社のXXについては以前から興味を感じており、XXな部分に大変魅力を感じます。今までの経験を活かしながら、さらにXXなどのスキルを身につけ、貴社におけるXX業務に貢献したいと考え志望しました。',
    '事業内容に関心がある': '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。',
    '自身の経験を活かしたい': '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。',
    '企業のビジョンに共感した': '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。',
    '裁量の大きさに魅力を感じた': '貴社の個々の裁量が大きい職場環境に対して魅力を感じ、今回応募いたしました。責任感を持ちながら、工夫を重ねて成果を出していく職場環境であるということに、自身が成長できる可能性と魅力を感じます。',
    '社員に魅力を感じた': '貴社で働かれている社員の方々をXXXXで拝見し、その働き方に魅力を感じて応募いたしました。その中でもXXXという点が、自身の価値観や仕事感に近いと感じました。XXXXを行うことで、貴社への価値貢献をしたいと考えております。',
    '未経験職種へ転職したい': '前職ではXXに従事しておりましたが、よりXXに貢献できるような仕事をしたいと考えておりました。今回、貴社のXX求人を拝見し自分もこのような環境で挑戦してみたいと考え、転職を決意致しました。',
    '一度離れた職種に戻りたい': '前職ではXX業務に携わり貴重な経験を得ましたが、もう一度XXに戻りたいという思いが強くなりこの度貴社を志望致しました。今までの実務経験の強みを活かしながら、新しい技術に関しても積極的に勉強していきたいと考えています。'
  },
  // 資格
  license: {
    '自動車免許(MT車)': '普通自動車第一種運転免許取得',
    '自動車免許(AT限定)': '普通自動車第一種運転免許（AT限定）取得',
    '英検': '実用英語技能検定X級合格',
    'TOEIC': 'TOEIC公開テストXXX点取得',
    'TOEFL': 'iBTテストスコアX点取得',
    '日商簿記': '日商簿記検定試験X級合格',
    'ファイナンシャルプランナー': 'ファイナンシャルプランナーX級合格'
  },
  // 본인희망란
  request: {
    '連絡可能な時間帯': '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。',
    '帰社時間の希望': '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。',
    '希望職種': '希望職種：XX職を希望します。',
    '希望年収': '現在の年収はOOO万円です。希望年収はXXX万円となります。',
    '特に希望がない場合': '貴社規定に従います。'
  }
}

const licenseCommon = {
  '原付免許': '原動機付自転車免許取得',
  '自動車免許': '普通自動車第一種運転免許取得',
  '自動車免許(AT限)': '普通自動車第一種運転免許(AT限定)取得',
  '英検': '実用英語技能検定X級合格',
  'TOEIC': 'TOEIC公開テストXXX点取得',
  'TOEFL': 'iBTテストスコアX点取得',
  '日商簿記': '日商簿記検定試験X級合格',
  'ファイナンシャルプランナー': 'ファイナンシャルプランナーX級合格'
}

const formatsIndex = [
  new FormatItem({
    id: 'letter',
    title: '送付状',
    description: 'A4サイズの送付状テンプレートです。送付状を入れておくことで、丁寧な印象を与えることができます。面接官の印象がガラッと変わるので、1枚入れておくことをオススメします。',
    thumbnail: '/kr/resume/static/img/formats/sample/yagish_letter_img.jpeg',
    images: [
      '/kr/resume/static/img/formats/sample/yagish_letter_img.jpeg'
    ],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '全36種類のあいさつ季語を例文から選べます',
    newdetail: '',
    requiredBasicFields: ['name', 'address', 'tel', 'email'],
    hashs: ['送付状'],
    components: {
      edit: LetterEdit,
      preview: LetterPreview
    },
    cards: LetterCards,
    sampleData: LetterSample,
    exampleSentences: {
      intro: [
        { type: 'others', name: '一般的なあいさつ', sentences: '拝啓　貴社におかれましてはますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '一般的なあいさつ', sentences: '拝啓　貴社ますますご清栄のこととお慶び申し上げます' },
        { type: 'others', name: '1月のあいさつ', sentences: '拝啓　初春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '1月のあいさつ', sentences: '拝啓　新春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '1月のあいさつ', sentences: '拝啓　厳冬の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '2月のあいさつ', sentences: '拝啓　立春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '2月のあいさつ', sentences: '拝啓　早春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '2月のあいさつ', sentences: '拝啓　残寒の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '3月のあいさつ', sentences: '拝啓　春分の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '3月のあいさつ', sentences: '拝啓　春陽の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '3月のあいさつ', sentences: '拝啓　浅春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '4月のあいさつ', sentences: '拝啓　春暖の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '4月のあいさつ', sentences: '拝啓　陽春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '4月のあいさつ', sentences: '拝啓　仲春の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '5月のあいさつ', sentences: '拝啓　新緑の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '5月のあいさつ', sentences: '拝啓　薫風の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '5月のあいさつ', sentences: '拝啓　立夏の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '6月のあいさつ', sentences: '拝啓　小夏の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '6月のあいさつ', sentences: '拝啓　入梅の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '6月のあいさつ', sentences: '拝啓　梅雨の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '7月のあいさつ', sentences: '拝啓　盛夏の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '7月のあいさつ', sentences: '拝啓　仲夏の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '7月のあいさつ', sentences: '拝啓　猛暑の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '8月のあいさつ', sentences: '拝啓　残暑の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '8月のあいさつ', sentences: '拝啓　晩夏の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '8月のあいさつ', sentences: '拝啓　立秋の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '9月のあいさつ', sentences: '拝啓　初秋の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '9月のあいさつ', sentences: '拝啓　新秋の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '9月のあいさつ', sentences: '拝啓　秋冷の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '10月のあいさつ', sentences: '拝啓　仲秋の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '10月のあいさつ', sentences: '拝啓　秋涼の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '10月のあいさつ', sentences: '拝啓　秋晴の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '11月のあいさつ', sentences: '拝啓　晩秋の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '11月のあいさつ', sentences: '拝啓　向寒の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '11月のあいさつ', sentences: '拝啓　菊花の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '12月のあいさつ', sentences: '拝啓　師走の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '12月のあいさつ', sentences: '拝啓　初冬の候、貴社ますますご繁栄のこととお慶び申し上げます。' },
        { type: 'others', name: '12月のあいさつ', sentences: '拝啓　寒冷の候、貴社ますますご繁栄のこととお慶び申し上げます。' }
      ],
      entry: [
        { type: 'others', name: '一般的な応募経緯', sentences: 'この度、貴社の○○職に応募させて頂きたく、下記の応募書類を送付させて頂きます。\nぜひご検討頂き、面接の機会を頂けますと幸いに存じます。何卒宜しくお願い申し上げます。' },
        { type: 'others', name: '詳細に経緯を説明', sentences: 'この度、〇〇に掲載されておりました、〇〇職の求人に応募させていただきます。\n\n私は３年間にわたり海外営業として勤務しており、国内勤務をしながら海外の顧客を担当してまいりました。これまでの経験を活かして貴社の〇〇業務に貢献したいと考え、応募させていただきました。\n\nご検討の上、是非ともご面談の機会をいただけますと幸いです。\n\nご査収のほど、宜しくお願い申し上げます。' },
      ],
      resume: [
        { type: 'others', name: '', sentences: 'はじめての転職大学卒業。' },
        { type: 'others', name: '', sentences: '2社の転職を経験大学を卒業。' },
        { type: 'others', name: '', sentences: '複数の転職を経験大学を卒業。' }
      ],
      prMessage: [
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        }
      ]
    }
  })
  // new FormatItem({
  //   id: 'rirekisho_wareki',
  //   title: '【和暦】転職用の履歴書（JIS規格）',
  //   description: '（ベータ版）和暦表記の日本工業規格（JIS）の規格に従ったA4サイズの一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
  //   thumbnail: '/kr/resume/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_02.jpg'
  //   ],
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoPreviewWareki
  //   },
  //   cards: RirekishoCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeExampleSentences
  // })
]


// if (process.env.VUE_APP_MODE !== 'production') {
//   formatsIndex.push(new FormatItem({
//     id: 'shokumukeirekisho',
//     title: '職務経歴書',
//     description: '（ベータ版）A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。',
//     // thumbnail: '/kr/resume/static/img/formats/rirekisho_job_change.png',
//     thumbnail: '/kr/resume/static/img/formats/shokurekisho-min.png',
//     images: [
//       // '/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg',
//       // '/kr/resume/static/img/formats/sample/rirekisho_job_change_02.jpg'
//       '/kr/resume/static/img/formats/sample/shokurekisho.png'
//     ],
//     requiredBasicFields: ['name'],
//     hashs: ['職務経歴書'],
//     components: {
//       edit: ShokurekishoEdit,
//       preview: ShokurekishoPreview
//     },
//     // cards: RirekishoCards,
//     cards: ShokurekiCards,
//     sampleData: ShokurekishoSample,
//     // exampleSentences: jobChangeExampleSentences
//     exampleSentences: {
//       summary: [
//         {type: 'others', name: 'はじめての転職', sentences: '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'},
//         {type: 'others', name: '2社の転職を経験', sentences: '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'},
//         {type: 'others', name: '複数社の転職を経験', sentences: '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'}
//         // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
//         // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
//         // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
//         // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
//       ],
//       prMessage: [
//         {type: 'others', name: 'スキルをアピール', sentences: '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
//         },
//         {type: 'others', name: '同業種・業界での経験をアピール', sentences: '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: 'マネジメント経験をアピール', sentences: '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: '事務能力の高さ・効率性をアピール', sentences: 'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
//         }
//         // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
//         // },
//         // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
//         // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
//         // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
//       ]
//     }
//   }))
// }
export default formatsIndex
